import { useMemo } from "react";

/**
 * Custom hook to create a memoized unit price map from product data.
 *
 * @param {Array} products - Array of product objects containing TechRefId and UnitPrice
 * @returns {Map} A Map with TechRefId as key and UnitPrice as value
 *
 * @example
 * const unitPriceMap = useUnitPriceMap(cspDetails?.cspDetails?.product);
 * const price = unitPriceMap.get(techRefId) ?? 0;
 */
export const useUnitPriceMap = (products) => {
  return useMemo(() => {
    const priceMap = new Map();

    // Check if products exists AND is actually an array before looping
    if (Array.isArray(products)) {
      products.forEach((item) => {
        // Ensure TechRefId exists and isn't null/undefined
        // Using != null handles both null and undefined, and allows 0 as valid TechRefId
        if (item?.TechRefId != null) {
          priceMap.set(item.TechRefId, item.UnitPrice);
        }
      });
    }

    return priceMap;
  }, [products]);
};
